import { Link, createFileRoute } from '@tanstack/react-router';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { guidePages, guideSections } from '@/lib/guide-structure';
import { WikiAnchorSection } from '@/components/wiki/WikiAnchorSection';
import { WikiToc } from '@/components/wiki/WikiToc';

export const Route = createFileRoute('/wiki/')({
  component: WikiHomePage,
});

function WikiHomePage() {
  const toc = [
    { id: 'what-this-guide-covers', label: 'What This Guide Covers' },
    { id: 'sections', label: 'Sections' },
    { id: 'fast-jumps', label: 'Fast Jumps' },
  ];

  return (
    <div className="space-y-5">
      <WikiToc items={toc} />

      <WikiAnchorSection id="what-this-guide-covers" title="What This Guide Covers">
        <p>
          This wiki is structured for fast, practical in-game use. It explains systems, timing windows,
          strategic tradeoffs, and how mechanics interact. To protect Mythea IP, we intentionally avoid
          exposing exact formula internals and implementation constants.
        </p>
        <div className="flex flex-wrap gap-2">
          <Badge>No raw formulas</Badge>
          <Badge>Context-first guidance</Badge>
          <Badge>Cross-linked pages</Badge>
        </div>
      </WikiAnchorSection>

      <WikiAnchorSection id="sections" title="Sections">
        <div className="grid gap-4 sm:grid-cols-2">
          {guideSections.map(section => (
            <Card key={section.id} className="p-4">
              <h3 className="font-cinzel text-lg text-[#f0f0f0]">{section.title}</h3>
              <p className="mt-2 text-sm text-[#b8b8b8]">{section.description}</p>
              <Link
                to="/wiki/$sectionId"
                params={{ sectionId: section.id }}
                className="mt-3 inline-flex rounded-lg border border-[#d4af37]/30 px-3 py-1.5 text-sm text-[#e6c547] hover:bg-[#d4af37]/12"
              >
                Open section
              </Link>
            </Card>
          ))}
        </div>
      </WikiAnchorSection>

      <WikiAnchorSection id="fast-jumps" title="Fast Jumps">
        <div className="grid gap-2 sm:grid-cols-2">
          {guidePages.map(page => (
            <Link
              key={page.path}
              to={page.path}
              className="rounded-lg border border-[#d4af37]/15 bg-[#111]/70 px-3 py-2 text-sm text-[#ddd] hover:border-[#d4af37]/35 hover:text-white"
            >
              <span className="font-semibold text-[#f0d060]">{page.title}</span>
              <span className="block text-xs text-[#a3a3a3]">{page.description}</span>
            </Link>
          ))}
        </div>
      </WikiAnchorSection>
    </div>
  );
}
